/* ND Product — variant picker, flavor themes, pricing, cart */
(function () {
  "use strict";

  const section = document.querySelector("[data-pdp-section]");
  const dataEl = document.querySelector('[id^="nd-product-data-"]');
  const form = document.querySelector("[data-nd-product-form]");
  if (!section || !dataEl || !form) return;

  const data = JSON.parse(dataEl.textContent);
  const buybox = document.querySelector("[data-buybox]");
  const variantInput = form.querySelector("[data-variant-id]");
  const planInput = form.querySelector("[data-selling-plan]");
  const qtyInput = form.querySelector("[data-qty-val]");
  const priceNow = document.querySelector("[data-price-now]");
  const priceWas = document.querySelector("[data-price-was]");
  const pricePer = document.querySelector("[data-price-per]");
  const subPrice = document.querySelector("[data-sub-price]");
  const oncePrice = document.querySelector("[data-once-price]");
  const subscribeMeta = document.querySelector("[data-subscribe-meta]");
  const planFrequency = document.querySelector("[data-plan-frequency]");
  const planPicker = document.querySelector("[data-plan-picker]");
  const addBtn = form.querySelector("[data-add]");
  const buyNowBtn = document.querySelector("[data-buy-now]");
  const mainImg = document.getElementById("nd-pdp-main-image");
  const bgEl = section.querySelector("[data-pdp-theme-bg]");
  let themeSwitchTimer = null;

  const norm = (v) => (v == null ? "" : String(v).trim());

  const urlKey = (src) => {
    if (!src) return "";
    try {
      const u = new URL(src, window.location.origin);
      return u.pathname;
    } catch (e) {
      return src.split("?")[0];
    }
  };

  const resolveInitialVariant = () => {
    const fromUrl = new URLSearchParams(window.location.search).get("variant");
    if (fromUrl) {
      const v = data.variants.find((x) => String(x.id) === String(fromUrl));
      if (v) return v;
    }
    if (variantInput?.value) {
      const v = data.variants.find((x) => String(x.id) === String(variantInput.value));
      if (v) return v;
    }
    return data.variants.find((v) => v.available) || data.variants[0];
  };

  const initialVariant = resolveInitialVariant();

  const state = {
    options: initialVariant ? initialVariant.options.slice() : data.options.map((o) => o.selected || o.values[0]),
    mode: data.variants.some((v) => v.selling_plans.length) ? "subscribe" : "once",
    planIndex: 0,
    qty: 1,
    manualGallerySrc: null,
  };

  const money = (cents) => {
    if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents, data.moneyFormat);
    return (cents / 100).toLocaleString("da-DK", { minimumFractionDigits: 2 }) + " kr";
  };

  const normalizeTheme = (theme) => {
    if (!theme) return data.themes._default;
    const bgTop = theme.bgTop || theme.bg || "#14110A";
    const bgMid = theme.bgMid || bgTop;
    const bgBottom = theme.bgBottom || "#050508";
    return {
      bgTop,
      bgMid,
      bgBottom,
      accent: theme.accent || "#C9A04A",
      glow: theme.glow || "rgba(201, 160, 74, 0.28)",
      tabFrom: theme.tabFrom || theme.accent || "#C9A04A",
      tabTo: theme.tabTo || theme.glow || "#FFCE36",
    };
  };

  const themeFromValue = (value) => {
    const key = norm(value);
    if (!key) return normalizeTheme(data.themes._default);
    if (data.themes[key]) return normalizeTheme(data.themes[key]);
    const lower = key.toLowerCase();
    if (lower.includes("lemon") || lower.includes("citron")) return normalizeTheme(data.themes._lemon);
    if (lower.includes("peach") || lower.includes("fersken")) return normalizeTheme(data.themes._peach);
    if (lower.includes("mixed") || lower.includes("blandet") || lower.includes("mix")) {
      return normalizeTheme(data.themes._mixed);
    }
    return normalizeTheme(data.themes._default);
  };

  const themeForOptions = () => {
    const flavorValue = state.options[data.colorOptionIndex] || "";
    return themeFromValue(flavorValue);
  };

  const findVariant = () => {
    let match = data.variants.find((v) =>
      v.options.every((opt, i) => norm(opt) === norm(state.options[i]))
    );

    if (!match) {
      const flavor = state.options[data.colorOptionIndex];
      match =
        data.variants.find(
          (v) => norm(v.options[data.colorOptionIndex]) === norm(flavor) && v.available
        ) ||
        data.variants.find((v) => norm(v.options[data.colorOptionIndex]) === norm(flavor)) ||
        data.variants[0];

      if (match) state.options = match.options.slice();
    }

    return match;
  };

  const packSize = (variant) => {
    const joined = (variant.options || []).join(" ").toLowerCase();
    const match = joined.match(/(\d+)\s*(pcs|pack|stk|cans)?/);
    return match ? parseInt(match[1], 10) : 12;
  };

  const applyTheme = (theme, flavorLabel, animate) => {
    if (!theme) return;

    section.style.setProperty("--pdp-bg-top", theme.bgTop);
    section.style.setProperty("--pdp-bg-mid", theme.bgMid);
    section.style.setProperty("--pdp-bg-bottom", theme.bgBottom);
    section.style.setProperty("--pdp-accent", theme.accent);
    section.style.setProperty("--pdp-glow", theme.glow);
    section.style.setProperty("--pdp-tab-from", theme.tabFrom);
    section.style.setProperty("--pdp-tab-to", theme.tabTo);

    if (flavorLabel) section.dataset.pdpFlavor = flavorLabel;

    const baseGradient = `linear-gradient(165deg, ${theme.bgTop} 0%, ${theme.bgMid} 45%, ${theme.bgBottom} 100%)`;
    if (bgEl) bgEl.style.background = baseGradient;

    if (animate) {
      section.classList.add("is-theme-switching");
      window.clearTimeout(themeSwitchTimer);
      themeSwitchTimer = window.setTimeout(() => {
        section.classList.remove("is-theme-switching");
      }, 680);
    }
  };

  const mediaForVariant = (variant) => {
    if (variant.featured_media_id) {
      const m = data.media.find((x) => x.id === variant.featured_media_id);
      if (m) return m.src;
    }
    const val = state.options[data.colorOptionIndex];
    if (val && data.valueMedia[val]) return data.valueMedia[val];
    return data.media[0]?.src || "";
  };

  const setMainImage = (src) => {
    if (!mainImg || !src) return;

    const nextKey = urlKey(src);
    const currentKey = urlKey(mainImg.currentSrc || mainImg.src);
    if (nextKey && currentKey && nextKey === currentKey) return;

    mainImg.classList.add("is-swapping");
    window.setTimeout(() => {
      mainImg.removeAttribute("srcset");
      mainImg.removeAttribute("sizes");
      mainImg.src = src;
      mainImg.classList.remove("is-swapping");
    }, 120);
  };

  const syncThumbActive = (src) => {
    const targetKey = urlKey(src);
    if (!targetKey) return;

    section.querySelectorAll(".pdp-thumbs button").forEach((btn) => {
      const btnKey = urlKey(btn.dataset.full);
      btn.classList.toggle("active", btnKey === targetKey);
    });
  };

  const renderPlanPicker = (variant) => {
    if (!planPicker || !subscribeMeta) return;

    const plans = variant.selling_plans || [];
    const showMeta = state.mode === "subscribe" && plans.length > 0;

    subscribeMeta.hidden = !showMeta;
    if (!showMeta) {
      planPicker.hidden = true;
      planPicker.innerHTML = "";
      if (planFrequency) planFrequency.textContent = "";
      return;
    }

    const activePlan = plans[Math.min(state.planIndex, plans.length - 1)] || plans[0];
    if (planFrequency) {
      planFrequency.textContent = activePlan?.name || "Recurring delivery";
    }

    if (plans.length <= 1) {
      planPicker.hidden = true;
      planPicker.innerHTML = "";
      return;
    }

    planPicker.hidden = false;
    planPicker.innerHTML = plans
      .map(
        (plan, index) =>
          `<button type="button" class="pdp-plan-pill${index === state.planIndex ? " active" : ""}" data-plan-index="${index}" aria-pressed="${index === state.planIndex}">${plan.name}</button>`
      )
      .join("");

    planPicker.querySelectorAll("[data-plan-index]").forEach((btn) => {
      btn.addEventListener("click", () => {
        state.planIndex = parseInt(btn.dataset.planIndex, 10) || 0;
        render(false);
      });
    });
  };

  const render = (animateTheme, options = {}) => {
    const variant = findVariant();
    if (!variant) return;

    if (options.resetGallery) state.manualGallerySrc = null;

    variantInput.value = variant.id;

    const flavorValue = state.options[data.colorOptionIndex] || "";
    applyTheme(themeForOptions(), flavorValue, animateTheme);

    const gallerySrc = state.manualGallerySrc || mediaForVariant(variant);
    setMainImage(gallerySrc);
    if (!state.manualGallerySrc) syncThumbActive(gallerySrc);

    const hasPlans = variant.selling_plans.length > 0;
    const plan = hasPlans ? variant.selling_plans[Math.min(state.planIndex, variant.selling_plans.length - 1)] : null;
    const subscribe = state.mode === "subscribe" && plan;

    renderPlanPicker(variant);

    if (planInput) {
      planInput.value = subscribe ? plan.id : "";
      planInput.disabled = !subscribe;
    }

    const base = variant.price * state.qty;
    const final = subscribe ? plan.price * state.qty : base;

    if (priceNow) priceNow.textContent = money(final);
    if (priceWas) {
      if (subscribe && base > final) {
        priceWas.textContent = money(base);
        priceWas.style.display = "inline";
      } else if (variant.compare_at_price > variant.price) {
        priceWas.textContent = money(variant.compare_at_price * state.qty);
        priceWas.style.display = "inline";
      } else {
        priceWas.style.display = "none";
      }
    }

    const cans = packSize(variant) * state.qty;
    if (pricePer) pricePer.textContent = money(Math.round(final / cans)) + " " + (data.perUnitText || "/ dåse");

    if (subPrice && plan) subPrice.textContent = money(plan.price);
    if (oncePrice) oncePrice.textContent = money(variant.price);

    state.options.forEach((val, i) => {
      const label = section.querySelector(`[data-pdp-opt-label-${i + 1}]`);
      if (label) label.textContent = val;
    });

    form.querySelectorAll("[data-pdp-option]").forEach((btn) => {
      const idx = parseInt(btn.dataset.pdpOption, 10) - 1;
      const active = norm(state.options[idx]) === norm(btn.dataset.pdpValue);
      btn.classList.toggle("active", active);
      btn.setAttribute("aria-pressed", active ? "true" : "false");
      const swatchLabel = btn.closest(".pdp-swatch-item")?.querySelector(".pdp-swatch-label");
      if (swatchLabel) swatchLabel.classList.toggle("is-active", active);
    });

    form.querySelectorAll("[data-mode]").forEach((btn) => {
      const active = btn.dataset.mode === state.mode;
      btn.classList.toggle("active", active);
      btn.setAttribute("aria-pressed", active ? "true" : "false");
    });

    if (qtyInput) qtyInput.value = state.qty;

    if (addBtn) {
      addBtn.disabled = !variant.available;
      const defaultOnce = addBtn.dataset.defaultText || data.onceAddText || "Add to cart";
      const subscribeText = data.subscribeAddText || "Subscribe & Save";
      addBtn.textContent = variant.available
        ? subscribe
          ? subscribeText
          : defaultOnce
        : (data.soldOutText || "Udsolgt");
    }

    const stickyP = document.querySelector(".sticky-cart .info .p");
    const stickyT = document.querySelector(".sticky-cart .info .t");
    if (stickyP) stickyP.textContent = `${packSize(variant)} ${data.unitPluralText || "dåser"} · ${flavorValue} · ${money(final)}`;
    if (stickyT) stickyT.textContent = subscribe ? (data.subscribeAddText || "Abonnér og spar") : (data.onceModeText || "Engangskøb");
  };

  if (addBtn) addBtn.dataset.defaultText = addBtn.textContent;

  form.querySelectorAll("[data-pdp-option]").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      const idx = parseInt(btn.dataset.pdpOption, 10) - 1;
      const value = btn.dataset.pdpValue;
      if (norm(state.options[idx]) === norm(value)) return;

      const isFlavor = idx === data.colorOptionIndex;
      state.options[idx] = value;
      state.planIndex = 0;
      render(true, { resetGallery: isFlavor });
    });
  });

  form.querySelectorAll("[data-mode]").forEach((btn) => {
    btn.addEventListener("click", () => {
      state.mode = btn.dataset.mode;
      render(false);
    });
  });

  form.querySelector("[data-qty-dec]")?.addEventListener("click", () => {
    state.qty = Math.max(1, state.qty - 1);
    render(false);
  });

  form.querySelector("[data-qty-inc]")?.addEventListener("click", () => {
    state.qty = Math.min(20, state.qty + 1);
    render(false);
  });

  section.querySelectorAll(".pdp-thumbs button").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      const src = btn.dataset.full;
      if (!src) return;

      state.manualGallerySrc = src;
      setMainImage(src);
      section.querySelectorAll(".pdp-thumbs button").forEach((b) => b.classList.remove("active"));
      btn.classList.add("active");
    });
  });

  // Swipe the main image on touch devices. Steps through the same thumbnail
  // list the buttons use, so gallery state and thumb highlight stay in sync.
  (function enableGallerySwipe() {
    const stage = section.querySelector(".pdp-main-img");
    if (!stage) return;

    const thumbs = () => [...section.querySelectorAll(".pdp-thumbs button")];

    const currentIndex = () => {
      const list = thumbs();
      const active = list.findIndex((b) => b.classList.contains("active"));
      if (active !== -1) return active;
      // no active thumb yet: match by the image currently shown
      const shown = urlKey(mainImg && (mainImg.currentSrc || mainImg.src));
      const bySrc = list.findIndex((b) => urlKey(b.dataset.full) === shown);
      return bySrc === -1 ? 0 : bySrc;
    };

    const goTo = (i) => {
      const list = thumbs();
      if (!list.length) return;
      const clamped = (i + list.length) % list.length; // wrap around
      const btn = list[clamped];
      const src = btn.dataset.full;
      if (!src) return;
      state.manualGallerySrc = src;
      setMainImage(src);
      list.forEach((b) => b.classList.remove("active"));
      btn.classList.add("active");
    };

    let startX = 0;
    let startY = 0;
    let tracking = false;

    stage.addEventListener(
      "touchstart",
      (e) => {
        if (e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        tracking = true;
      },
      { passive: true }
    );

    stage.addEventListener(
      "touchend",
      (e) => {
        if (!tracking) return;
        tracking = false;
        const dx = e.changedTouches[0].clientX - startX;
        const dy = e.changedTouches[0].clientY - startY;
        // horizontal intent only, and enough distance to count as a swipe
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        goTo(currentIndex() + (dx < 0 ? 1 : -1));
      },
      { passive: true }
    );
  })();

  const addToCart = async (checkout) => {
    const variant = findVariant();
    if (!variant?.available) return;

    try {
      const body = { id: variant.id, quantity: state.qty };
      if (planInput?.value) body.selling_plan = planInput.value;

      const res = await fetch((window.routes?.cart_add_url || "/cart/add") + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(body),
      });
      if (!res.ok) throw new Error("Cart error");
      const cart = await fetch((window.routes?.cart_url || "/cart") + ".js").then((r) => r.json());
      if (window.syncCartCount) window.syncCartCount(cart.item_count);
      if (checkout) {
        window.location.href = "/checkout";
        return;
      }
      if (window.showToast) {
        const modeLabel = body.selling_plan ? "Subscription" : "Added";
        window.showToast(`${modeLabel} · ${state.qty}× ${variant.title}`);
      }
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    } catch (e) {
      form.submit();
    }
  };

  form.addEventListener("submit", (e) => {
    e.preventDefault();
    addToCart(false);
  });

  buyNowBtn?.addEventListener("click", () => addToCart(true));

  document.querySelector(".sticky-cart [data-add]")?.addEventListener("click", (e) => {
    e.preventDefault();
    addToCart(false);
  });

  const sticky = document.querySelector("[data-sticky-cart]");
  if (buybox && sticky) {
    new IntersectionObserver(
      (entries) =>
        entries.forEach((entry) => {
          const show = !entry.isIntersecting;
          sticky.classList.toggle("show", show);
          sticky.setAttribute("aria-hidden", show ? "false" : "true");
        }),
      { threshold: 0 }
    ).observe(buybox);
  }

  render(false);
})();